// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"c2139afe","279":"c2139afe","488":"b3f78817","538":"74a0312d","640":"3227cf18","789":"03d174c1"}[chunkId] + ".chunk.css";
};